import { Wiki } from "./components/Wiki";
import { Home } from "./components/Home";

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/emaildeliverability',
        element: <Home />
    },
    {
        path: '/wiki',
        element: <Wiki />
    },
];

export default AppRoutes;
